const CodeMap = {
  coins: {},
  drawBG: opt => {
    let o = {};
    Object.assign(o, { canvas: {}, width: 12, unit: 1 }, opt);

    o.canvas.width = o.width;
    o.canvas.height = o.width;
    const context = o.canvas.getContext("2d");
    context.fillStyle = "green";
    context.fillRect(0, 0, o.width, o.width);

    if (o.type === "background") drawGrid(o.canvas, context, o.unit);

    return context;
  },

  draw: opt => {
    let o = {};
    Object.assign(o, { context: {}, unit: 1 }, opt);

    if (o.canvas) {
      if (o.width) {
        o.canvas.width = o.width;
        o.canvas.height = o.width;
      }
      o.context = o.canvas.getContext("2d");
    }

    if (o.type === "image") drawImage(o);
    if (o.type === "sprite") CodeMap.coins = drawSprite(o);
    if (o.type === "rotate") drawRotate(o);
  },

  redrawCoins: opt => {
    const { positions } = opt;
    if (CodeMap.coins) CodeMap.coins.positions = positions;
  }
};

//=============================================================================

function drawGrid(canvas, ctx, unit) {
  const Height = canvas.height;
  const Width = canvas.width;

  ctx.strokeStyle = "#6ba9d2";
  ctx.lineWidth = 0.5;
  for (let i = 0; i < Height; i += unit) {
    ctx.moveTo(0, i);
    ctx.lineTo(Width, i);
    ctx.stroke();
  }
  for (let i = 0; i < Width; i += unit) {
    ctx.moveTo(i, 0);
    ctx.lineTo(i, Height);
    ctx.stroke();
  }
}

function drawImage(o) {
  const max = o.positions.length;
  const draw = () => {
    for (let idx = 0; idx < max; idx++) {
      o.context.drawImage(
        o.image,
        o.positions[idx].x * o.unit,
        o.positions[idx].y * o.unit,
        o.unit,
        o.unit
      );
    }
  };
  o.image.onload = draw;
  draw();
}

function drawSprite(o) {
  let that = {};
  let frameIndex = 0;
  let tickCount = 0;
  let ticksPerFrame = o.ticksPerFrame || 0;
  let numberOfFrames = o.numberOfFrames || 1;

  Object.assign(that, o);
  const frameWidth = 44;
  const frameHeight = 40;

  that.render = function() {
    that.context.clearRect(0, 0, that.width, that.width);

    const max = that.positions.length;
    for (let idx = 0; idx < max; idx++) {
      if (!that.positions[idx].no) {
        that.context.drawImage(
          that.image,
          frameIndex * frameWidth,
          0,
          frameWidth,
          frameHeight,
          that.positions[idx].x * that.unit,
          that.positions[idx].y * that.unit,
          that.unit,
          that.unit
        );
      }
    }
  };

  that.update = function() {
    tickCount += 1;

    if (tickCount > ticksPerFrame) {
      tickCount = 0;

      // If the current frame index is in range
      if (frameIndex < numberOfFrames - 1) {
        // Go to the next frame
        frameIndex += 1;
      } else {
        frameIndex = 0;
      }
    }
  };

  o.image.onload = () => {
    loop();
  };

  function loop() {
    window.requestAnimationFrame(loop);
    that.update();
    that.render();
  }
  loop();
  return that;
}

function drawRotate(o) {
  o.context.clearRect(0, 0, o.canvas.width, o.canvas.height);
  o.context.save();
  o.context.translate(
    o.positions[0].x * o.unit + o.moving[0].x + o.unit / 2,
    o.positions[0].y * o.unit + o.moving[0].y + o.unit / 2
  );
  o.context.rotate((o.degrees * Math.PI) / 180);
  o.context.drawImage(o.image, -o.unit / 2, -o.unit / 2, o.unit, o.unit);
  o.context.restore();
}

export default CodeMap;
